/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.DocumentsFinance = {
  rerenderTable: false,

  _gridApi: null,

  _gridOptions: {
    paginationPageSize: 10,
    headerHeight: 44,
    rowHeight: 44,
    rowStyle: { overflow: 'hidden' },
    domLayout: 'autoHeight',
    columnDefs: null,
    rowData: null,
    suppressHorizontalScroll: false,
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    getNodeChildDetails(node) {
      if (node.isLeaf) {
        return null;
      } else {
        return {
          group: true,
          key: node.category,
          children: node.children
        };
      }
    },
    onGridSizeChanged(event) {
      return event.api.sizeColumnsToFit();
    },
    onRowGroupOpened(event) {
      return resizeAgGridTable(`#${this.tableSelector}`, this, 1, false, false, 20);
    }
  },

  _onFloatingTopCount(totalRow) {
    return this._gridApi.setPinnedTopRowData([totalRow]);
  },

  _prepareGridData(sortedBidders, restrictedBidders) {
    const gridData = ReportUtils.prepareData(ChartData, sortedBidders, restrictedBidders);
    const gridDataWithoutSummary = gridData.slice(0, gridData.length - 1);
    const gridDataSummary = _.last(gridData);
    const rootNodes = _.filter(gridDataWithoutSummary, data => data.indent === 0);
    _.map(rootNodes, node => this._setChildren(gridDataWithoutSummary, node));
    return [rootNodes, gridDataSummary];
  },

  _setChildren(gridData, node) {
    const children = _.filter(gridData, rowData => node.id === rowData.parent);
    node.children = children;
    if (children.length <= 0) { return; }
    _.each(children, child => this._setChildren(gridData, child));
    return node;
  },

  _minMaxCellRenderer(params) {
    if (params.node.data.min === params.value) {
      return `<div class='pt-green'>${params.value}</div>`;
    } else if (params.node.data.max === params.value) {
      return `<div class='pt-red'>${params.value}</div>`;
    } else {
      return `<div>${params.value}</div>`;
    }
  },

  _linkToExportBid(bidId, bidderName) {
    let exportLink;
    if (!bidId) { return ''; }
    const tender_posting_id = DocumentsFinance._getQueryVariable('tender_posting_id');
    if (tender_posting_id) {
      exportLink = `${$('#financeGrid').data('exportLink')}?bid_id=${bidId}&tender_posting_id=${tender_posting_id}`;
    } else {
      exportLink = `${$('#financeGrid').data('exportLink')}?bid_id=${bidId}`;
    }

    const tooltip = I18n.t('v4.tenders.show_post.single_bid_export_tooltip', { bidder: bidderName });
    return "<span class='ag-header-button-spacer'></span>" +
      `<a href='${exportLink}' class='ag-header-button icon-btn button nano pt-download has-tip tip-top' title='${tooltip}' data-tooltip='${tooltip}'></a>`;
  },

  _getQueryVariable(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    let i = 0;

    while (i < vars.length) {
      const pair = vars[i].split("=");
      if (pair[0] === variable) { return pair[1]; }
      i++;
    }

    return false;
  },

  _coverageRenderer(params) {
    const output = Number(params.value).toFixed(2);
    if (output === 'NaN') { return '-'; } else { return output + '%'; }
  },

  refreshTableData(tableSelector) {
    const sortedBidders = BiddersUtils.getBidders('visible');
    const restrictedBidders = BiddersUtils.getBidders('restricted');
    const bidIds = BiddersUtils.getBidders('bidIds');
    const chartDataCategories = ReportUtils.filter_categories(ChartData, sortedBidders);
    const gridData = this._prepareGridData(sortedBidders, restrictedBidders);

    const biddersColumns = _.map(sortedBidders, sortedBidder => {
      const bidderIdx = chartDataCategories.indexOf(sortedBidder);
      const bidId = bidIds[sortedBidder];
      const exportLink = DocumentsFinance._linkToExportBid(bidId, sortedBidder);
      return {
        headerName: exportLink + sortedBidder,
        width: 400,
        suppressSizeToFit: true,
        children: [
          { headerName: "Price (" + ChartData.currency + ")", width: 120, suppressSizeToFit: true, field: "bidder" + bidderIdx, cellStyle: { textAlign: 'right' }, cellRenderer: params => this._minMaxCellRenderer(params) },
          { headerName: "Price %", width: 140, suppressSizeToFit: true, field: 'price_percentage' + bidderIdx, cellStyle: { textAlign: 'right' } },
          { headerName: "Cov. %", width: 70, suppressSizeToFit: true, field: 'coverage' + bidderIdx, cellStyle: { textAlign: 'right' }, cellRenderer: this._coverageRenderer },
          { headerName: "Changes", width: 70, suppressSizeToFit: true, field: 'changes' + bidderIdx, cellStyle: { textAlign: 'right' }, cellRenderer: this._coverageRenderer }
        ]
      };
    });

    const columnDefs =
      [
        { headerName: "Category", field: 'category', minWidth: 300, cellRenderer: 'agGroupCellRenderer', pinned: 'left' },
        { headerName: "Qty", field: 'quantity', width: 50, suppressSizeToFit: true, pinned: 'left' },
        { headerName: "Unit", field: 'unit', width: 50, suppressSizeToFit: true, pinned: 'left' }
      ].concat(biddersColumns);

    this._gridApi.setGridOption('columnDefs', columnDefs);
    this._gridApi.setGridOption('rowData', gridData[0]);
    this._onFloatingTopCount(gridData[1]);

    return resizeAgGridTable(`#${tableSelector}`, this._gridOptions, 1, false, false, 20);
  },

  initializeTable(tableSelector) {
    const gridDiv = document.getElementById(tableSelector);
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    return this.refreshTableData(tableSelector);
  }
};
